export default __webpack_public_path__ + "static/media/hotels-colusa.19fb937b.webp";